export const useProductAttributes = ({ variantsName, variantsType, variantsTitle }) => {
  const types = variantsType.split(':');
  const names = variantsName.split(':');
  const title = variantsTitle.split(":");
  const colorIndex = types.findIndex(item => item === 'Color');
  const colorName = names[colorIndex];

  const result = [{
    key: title[colorIndex],
    value: colorName
  }];

  names.forEach((item, index) => {
    // 颜色在外面已经处理了，所以遍历要过滤掉
    if (index !== colorIndex) {
      result.push({ key: title[index], value: item });
    }
  });
  
  return result;
}

export const useHandleAttributes = (attributes) => {
  // 过滤掉没有value值的参数
  const result = attributes.filter(item => !!item.value);
  return result;
}